import { useRef } from "react";
import { appConfigs } from "./appConfigs";
import { configParameters, remoteConfig } from "./common";
import { useMediaQuery } from "./useMediaQuery";
export var defaultCoverImages = [
    {
        name: "cover_web_prod_01",
        ext: ".jpg",
        about: {
            date_taken: 1564984800000,
            place: "Elashin",
            short: "Distribution of disaster recovery aids",
            more: "https://www.facebook.com/hashimukhfdn/photos/a.2419455304956720/2419455324956718/"
        }
    }
];
export var useBackground = function () {
    var is1080 = useMediaQuery("(max-width: 1920px)");
    var is1440 = useMediaQuery("(max-width: 2560px)");
    var image = useRef(generateBackgroundImage());
    var size;
    if (is1080)
        size = 1080;
    else if (is1440)
        size = 1440;
    else
        size = 3840;
    return {
        image: image.current,
        url: generateBackgroundImageUrl(size, image.current),
    };
};
export function generateBackgroundImageUrl(size, image) {
    if (!image)
        image = generateBackgroundImage();
    return appConfigs.storage.public + (image.name + "_" + size + image.ext);
}
export function generateBackgroundImage() {
    var config = remoteConfig();
    var coverImages = JSON.parse(config.getString(configParameters.coverImages));
    var limit = coverImages.length;
    var rand;
    do {
        rand = Math.floor(Math.random() * 10);
    } while (rand >= limit);
    return coverImages[rand];
}
//# sourceMappingURL=useBackground.js.map